import mapboxgl from 'mapbox-gl'
import styled from 'styled-components'
import { ReactNode, useContext, useEffect, useState } from 'react'
import { MapContext } from 'components/Mapbox/Mapbox'
import { createRoot } from 'react-dom/client'
import { renderToStaticMarkup } from 'react-dom/server'
const currentMarkers: mapboxgl.Popup[] = []

export const FeatureTooltip = ({
  layer,
  content,
}: {
  layer: string[]
  content: (e: any) => JSX.Element
}) => {
  const [popup, setPopup] = useState<mapboxgl.Popup | undefined>()
  var context = useContext(MapContext)
  var { map, changeDefault } = context

  useEffect(() => {
    if (!context.map || popup) return

    const placeholder = document.createElement('div')
    placeholder.className = 'featuretooltip-placeholder'

    createRoot(placeholder).render(<></>)

    const pop = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    })
      .setDOMContent(placeholder)
      .addTo(context.map)
    setPopup(pop)

  
  }, [context.map])

  useEffect(() => {

    if (!context.map || !popup) return
    var map = context.map
    layer.forEach((l) => {
      if (!map) return

      map.on('mousemove', l, (e) => {
        if (!map) return

        map.getCanvas().style.cursor = 'crosshair'

        const features = e.features
        if (!features) return
        const features_cleaned = features.map((f: any) => [
          f.layer.id,
          f.properties,
        ])
        var b = content(features_cleaned)

        popup.setLngLat(e.lngLat)
        popup.setHTML(renderToStaticMarkup(b))
      })

      map.on('mouseleave', l, () => {
        map.getCanvas().style.cursor = ''
        popup.setHTML('')
        popup.setLngLat([0, 0])
      })
    })
  }, [layer, map, popup])

  return <FeatureTooltipComponent>{content([])}</FeatureTooltipComponent>
}

const FeatureTooltipComponent = ({ children }: { children: ReactNode }) => {
  return (
    <HiddenStyledComponentForceCSSInjection>
      {children}
    </HiddenStyledComponentForceCSSInjection>
  )
}

function removeAllMarkers() {
  currentMarkers.forEach((m) => m.remove())
  currentMarkers.length = 0
}

const HiddenStyledComponentForceCSSInjection = styled.div`
  display: none;
  pointer-events: none;
`
